<template>
  <GdashTile
    icon="<path d='M16 9C22 9 22 13 22 13V15H16V13C16 13 16 11.31 14.85 9.8C14.68 9.57 14.47 9.35 14.25 9.14C14.77 9.06 15.34 9 16 9M2 13C2 13 2 9 8 9S14 13 14 13V15H2V13M9 17V19H15V17L18 20L15 23V21H9V23L6 20L9 17M8 1C6.34 1 5 2.34 5 4S6.34 7 8 7 11 5.66 11 4 9.66 1 8 1M16 1C14.34 1 13 2.34 13 4S14.34 7 16 7 19 5.66 19 4 17.66 1 16 1Z' />"
    header="Median Age"
  >
    <div class="tile-description">
      The median age is
      <b>{{ data.medianAge | format("n1") }} years</b>
    </div>
    <wj-flex-chart
      ref="medianAgeChart"
      class="chart chart-median"
      plotMargin="40 0 60 0"
      tooltipContent="{y} people <br/> are {x}"
      chartType="Column"
      bindingX="name"
      :itemsSource="getAgeData()"
      :palette="palette"
    >
      <wj-flex-chart-series binding="value" />
      <wj-flex-chart-axis
        wjProperty="axisX"
        majorTickMarks="None"
        :majorGrid="false"
        :axisLine="true"
        :labels="true"
      />
      <wj-flex-chart-axis wjProperty="axisY" position="None" />
      <wj-flex-chart-data-label position="Top" content="{y}" :offset="5" />
      <wj-flex-chart-animation />
    </wj-flex-chart>
  </GdashTile>
</template>

<script>
import GdashTile from "./GdashTile.vue";
import * as wjcCore from "@mescius/wijmo";

export default {
  name: "MedianAgeTile",
  components: {
    GdashTile,
  },
  props: {
    data: Object,
    palette: Array,
  },
  filters: {
    format(value, fmt) {
      return wjcCore.Globalize.format(value, fmt);
    },
  },
  methods: {
    getAgeData() {
      const data = this.data;
      const ageData = [
        {
          name: "Children",
          value: data.pop15,
        },
        {
          name: "Youth",
          value: data.pop15_24,
        },
        {
          name: "Adults",
          value: data.pop25_64,
        },
        {
          name: "Senior",
          value: data.pop64,
        },
      ];

      return ageData;
    },
  },
};
</script>
